/*eslint-disable*/
import styled from 'styled-components'
import React, { useState } from 'react'
import Dropdown, { components } from 'react-select'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'components/Tooltip'

import { TrailingIconsContainer } from 'components/Input/style'
import ErrorIcon from 'assets/icons/error-input-trailing-icon'
import DropDownIndicatorClosedIcon24 from 'assets/icons/dropdown-indicator-closed24px'
import DropDownIndicatorClosedIcon16 from 'assets/icons/dropdown-indicator-closed16px'
import DropdownIndicatorOpenedIcon24 from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorOpenedIcon16 from 'assets/icons/dropdown-indicator-opened16px'
import InfoIcon from 'assets/icons/info-icon16px'
import SearchIcon from 'assets/icons/search-icon'
import { SearchSelectIconContainer, SearchSelectIconWrapper } from './styles'
import { Label, Error, SelectContainer } from './styles'

const SelectTrailingIconsContainer = styled(TrailingIconsContainer)`
  right: 32px;

  img {
    margin-right: 0;
  }
`

const DropdownIndicatorClosedHOC = (indicatorSize) => {
  const DropdownIndicator = (props) => {
    const src =
      indicatorSize === 'small' ? (
        <DropDownIndicatorClosedIcon16 />
      ) : indicatorSize === 'none' ? (
        <div />
      ) : (
        <DropDownIndicatorClosedIcon24 />
      )
    return <components.DropdownIndicator {...props}>{src}</components.DropdownIndicator>
  }
  DropdownIndicator.displayName = `DropdownIndicator(${indicatorSize})`
  return DropdownIndicator
}

const DropdownIndicatorOpenedHOC = (indicatorSize) => {
  const DropdownIndicator = (props) => {
    const src =
      indicatorSize === 'small' ? (
        <DropdownIndicatorOpenedIcon16 />
      ) : indicatorSize === 'none' ? (
        <div />
      ) : (
        <DropdownIndicatorOpenedIcon24 />
      )
    return <components.DropdownIndicator {...props}>{src}</components.DropdownIndicator>
  }
  DropdownIndicator.displayName = `DropdownIndicator(${indicatorSize})`
  return DropdownIndicator
}

const PlaceholderWrap = (placeholderId) => {
  return function Placeholder(props) {
    return (
      <components.Placeholder {...props}>
        <span style={{ paddingLeft: '8px', color: 'rgba(32, 32, 32, 0.7)', opacity: '0.7' }}>
          <FormattedMessage id={placeholderId} />
        </span>
      </components.Placeholder>
    )
  }
}

const SingleValueDefault = (props) => {
  return <components.SingleValue {...props} />
}

const MenuListDefault = (props) => {
  return <components.MenuList className='scroll' {...props} />
}

const InputWithTitle = (props) => {
  const inputTitle = props?.selectProps?.title
  return <components.Input {...props} title={inputTitle} aria-label={inputTitle} />
}

const tooltipXOffset = 0
const tooltipYOffset = -16

const Select = ({
  value,
  onChange,
  options,
  label,
  field,
  error,
  errorMarginTop = "16px",
  placeholder,
  height = '48px',
  menuPlacement,
  marginTop = '8px',
  marginBottom = '32px',
  indicatorSize,
  dataTest,
  disabled,
  placeholderComponent: PlaceholderComponent,
  closeMenuOnSelect = true,
  singleValueComponent: SingleValueComponent,
  menuListComponent: MenuListComponent,
  infoTooltip,
  zIndex,
  isSearchable = false,
  paddingLeft = `${isSearchable ? '30px' : '8px'}`,
  menuWidth = '100%',
  menuIsOpen,
  onFocus,
  onBlur,
  inputValue,
  onInputChange,
  isOptional = false,
  link,
  twoStepWidth,
  hyper,
  searchDropdown = false,
  marginBottomLabel,
  inputMargin = '12px 0 12px 8px',
  filterOption,
  title,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const errorBorderStyle = '1px solid rgba(225, 25, 0, 0.5)'
  const defaultBorderStyle = '1px solid rgba(32, 32, 32, 0.2)'
  const focusBorderStyle = '1px solid #0AA1F4'

  const defaultBoxShadow = '0px 1px 2px rgba(32, 32, 32, 0.05)'
  const focusBoxShadow = '0px 1px 2px rgba(32, 32, 32, 0.05), 0px 0px 0px 4px rgba(10, 161, 244, 0.1);'

  const defaultBorderColor = 'rgba(32, 32, 32, 0.2)'
  const focusBorderColor = '#0AA1F4'

  const customStyles = {
    control: (provided, state) => {
      let border = state.isFocused ? focusBorderStyle : defaultBorderStyle;
      const boxShadow = state.isFocused ? focusBoxShadow : defaultBoxShadow;
      if (error && error.field === field) {
        border = errorBorderStyle;
      }

      const borderColor = state.isFocused ? focusBorderColor : defaultBorderColor;
      return {
        ...provided,
        width: '100%',
        height: height,
        minHeight: height,
        marginBottom: '0px',
        background: state.isDisabled ? 'rgba(32, 32, 32, 0.02)' : 'rgba(255, 255, 255, 1)',
        outline: 'transparent',
        borderColor,
        borderWidth: '1px',
        border,
        boxShadow,
        paddingLeft: paddingLeft,
        '&:hover': {
          border: '1px solid rgba(32, 32, 32, 0.2)',
          boxShadow: '0px 2px 8px -2px rgba(32, 32, 32, 0.1)',
        },
      };
    },
    indicatorSeparator: () => {
      return {
        display: 'none',
      };
    },
    multiValue: (provided) => {
      return {
        ...provided,
        display: 'flex',
        alignItems: 'center',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      };
    },
    multiValueLabel: (provided) => {
      return {
        ...provided,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      };
    },
    menu: (provided) => {
      const width = menuWidth;
      const zIndex = 2;
      return {
        ...provided, width, zIndex,
        wordWrap: 'break-word',
      };
    },
    option: (provided, state) => {
      return {
        ...provided,
        ':hover': {
          background: state.isSelected ? 'rgba(32, 32, 32, 0.05)' : 'rgba(32, 32, 32, 0.03)',
        },
        background: state.isSelected ? '#fff' : '#fff',
        color: state.isSelected ? 'rgba(32, 32, 32)' : 'rgba(32, 32, 32)',
        minHeight: height,
        paddingLeft: '16px',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'normal', // Allow text to wrap
        wordWrap: 'break-word', // Break long words
      };
    },
    placeholder: (provided) => ({
      ...provided,
      marginLeft: '8px',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    }),
    input: (provided) => {
      const margin = inputMargin;
      return { ...provided, margin };
    },
    singleValue: (provided) => {
      const width = searchDropdown ? '80%' : '100%';

      if (twoStepWidth) {
        return {
          ...provided,
          width: '250px',
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        };
      }
      return {
        ...provided,
        width,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      };
    },
    valueContainer: (provided) => {
      return {
        ...provided,
      };
    },
    menuPortal: (base) => ({
      ...base,
      zIndex: 999999,
    }),
  };


  //const DropdownIndicator = isDropdownOpen ? DropdownIndicatorOpenedHOC(indicatorSize) : DropdownIndicatorClosedHOC(indicatorSize)
  const DropdownIndicator = isDropdownOpen ? DropdownIndicatorClosedHOC(indicatorSize) : DropdownIndicatorClosedHOC(indicatorSize)
  const Placeholder = PlaceholderComponent ? PlaceholderComponent : PlaceholderWrap(placeholder, isSearchable)
  const SingleValue = SingleValueComponent ? SingleValueComponent : SingleValueDefault
  const MenuList = MenuListComponent ? MenuListComponent : MenuListDefault

  const onBlurHandler = () => {
    setIsDropdownOpen(false)
    if (onBlur) {
      onBlur()
    }
  }

  const toggleDropdown = () => {
    if (disabled) {
      return
    }
    setIsDropdownOpen(!isDropdownOpen)
  }


  return (
    <SelectContainer data-testid='test-select-container' marginBottom={marginBottom} onClick={toggleDropdown}>
      {React.isValidElement(label)
        ? label
        : label && (
          <>
            <Label htmlFor={`dropdown-${field}`} data-test={`label-${dataTest}`} marginBottomLabel={marginBottomLabel}>
              <section style={{ display: 'flex', alignItems: 'center' }}>
                <FormattedMessage id={label} />
                {infoTooltip && (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    zIndex={zIndex}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: label, infoTooltip: infoTooltip }}
                    link={link}
                    hyper={hyper}
                  >
                    <div>
                      <InfoIcon />
                    </div>
                  </Tooltip>
                )}
              </section>
              <span>{isOptional && <FormattedMessage id='optional' />}</span>
            </Label>
            {isSearchable && (
              <SearchSelectIconContainer>
                <SearchSelectIconWrapper>
                  <SearchIcon />
                </SearchSelectIconWrapper>
              </SearchSelectIconContainer>
            )}
          </>
        )}
      <div style={{ position: 'relative' }}>
        <Dropdown
          components={{ DropdownIndicator, Placeholder, SingleValue, MenuList, Input: InputWithTitle }}
          id={`dropdown-${field}`}
          value={value}
          onChange={onChange}
          styles={customStyles}
          options={options}
          menuPlacement={menuPlacement || 'auto'}
          menuPortalTarget={document.body}
          data-test={dataTest}
          isSearchable={isSearchable}
          isDisabled={disabled}
          closeMenuOnSelect={closeMenuOnSelect}
          menuIsOpen={menuIsOpen}
          onFocus={onFocus}
          onBlur={onBlurHandler}
          inputValue={inputValue}
          onInputChange={onInputChange}
          filterOption={filterOption}
          title={title}
        />
        <SelectTrailingIconsContainer>
          {error && error.field === field && (
            <>
              <ErrorIcon />
            </>
          )}
        </SelectTrailingIconsContainer>
      </div>
      {error && error.field === field && (
        <Error errorMarginTop={errorMarginTop} data-test='validation-error-message'>
          <FormattedMessage id={error.error} />
        </Error>
      )}
    </SelectContainer>
  )
}

export default Select